export default function ViewReportDirectiveController(
  reportsDataService,
) {
  const vm = this;

  vm.iconType = vm.iconType || 'visibility';
  vm.iconSizeClass = vm.iconSizeClass || 'md-36';
  vm.iconColorClass = vm.iconColorClass || 'fc-navanta-charcoal-75';
  vm.handleClick = _handleClick;
  vm.createClass = _createClass;

  function _createClass() {
    return `${vm.iconSizeClass} ${vm.iconColorClass}`;
  }

  function _handleClick() {
    reportsDataService.getReportBlob(vm.reportInstanceId).then((viewReportResponse) => {
      reportsDataService.viewReportBlob(viewReportResponse);
    });
  }
}

ViewReportDirectiveController.$inject = [
  'reportsDataService',
];
